import { Title, type NavbarProps } from "lola-framework-ui-test";
import { BackArrowLight } from "../assets/navIcons";

const toIconColors = (color: string): [string, string] => {
  if (!color.includes("gradient")) return [color, color];
  const stops = color.split(",");
  return [stops[1].split(" ")[1], stops[2].split(" ")[1]];
};

/**
 * Drop-in for lola `Navbar` (same markup and class names) that renders the
 * stroke back arrow at 36px, matching the sheet header back/close icons.
 */
export const Navbar: React.FC<NavbarProps> = ({
  title = "",
  backUrl,
  icon,
  disabled = false,
  onIconClick = () => {},
  onBackClick = () => {},
  noBackButton = false,
  className = "",
  color = "#000",
  backIconColors,
  align = "left",
  isLeaving = false,
  textAnimated = false,
  textAnimatedDelay = 0,
  ...props
}) => {
  const navbarClassName = ["lola-navbar", `lola-navbar-${align}`, className]
    .filter(Boolean)
    .join(" ");
  const iconClassName = [
    "lola-navbar--container--icon",
    `lola-navbar--container--icon--${disabled ? "disabled" : "active"}`,
  ].join(" ");

  return (
    <div className={navbarClassName} {...props}>
      {noBackButton ? (
        <span />
      ) : (
        <BackArrowLight
          size={36}
          colors={backIconColors ?? toIconColors(color)}
          className="lola-navbar--back-icon"
          onClick={() => onBackClick(backUrl ?? "")}
        />
      )}
      <section className="lola-navbar--container">
        <Title
          color={color}
          title={title}
          align={align}
          isLeaving={isLeaving}
          textAnimated={textAnimated}
          textAnimatedDelay={textAnimatedDelay}
        />
        {icon && (
          <section onClick={onIconClick} className={iconClassName}>
            {icon}
          </section>
        )}
      </section>
    </div>
  );
};
